import header from './header';

import './header.scss';

export default angular.module('App.header', []).component('headerSite', header)
  .name;
